import { Order } from '@@types'
import InfiniteScroll from 'react-infinite-scroll-component'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import { PaymentVerifier } from '@features/payment/ui/payment-verifier/PaymentVerifier'

import { OrderCard } from '@widgets/order-card'


import styles from './styles.module.scss'

type OnlineOrdersListProps = {
  orders: Order[]
  hasMore: boolean
  fetchNextPage: () => void
  refetch: () => void
}

export default function OnlineOrdersList ({
  orders,
  fetchNextPage,
  hasMore,
  refetch
}: OnlineOrdersListProps) {

  return (
    <InfiniteScroll
      className={styles.root}
      dataLength={orders.length}
      next={fetchNextPage}
      hasMore={hasMore}
      loader={
        <SkeletonTheme>
          <Skeleton
            count={3}
            width="100%"
            height={120}
            style={{ borderRadius: 16, marginBottom: 20 }}
          />
        </SkeletonTheme>
      }
    >
      {orders.map((item, index) => (
        <OrderCard
          key={`${item?.id}-${index}`}
          order={item}
          isInitialOpen={index === 0}
          onUpdate={refetch}
        />
      ))}
      <PaymentVerifier isOrder onFinish={refetch} />
    </InfiniteScroll>
  )
}
